var BreakStatement = {
  print: function print() {
    return 'break;';
  }
};
module.exports = BreakStatement;